import { DAY_END } from './types';

export default class DayEndTime {
  static isTimeSmallerThanDayEnd(date: Date): boolean {
    const result = this.getTimeForDayEndCheck(date) < this.getDayEnd();
    return result; //for debug
  }
  static isTimeGreaterThanDayEnd(date: Date): boolean {
    const result = this.getTimeForDayEndCheck(date) > this.getDayEnd();
    return result; //for debug
  }
  static isTimeGreaterOrEqualsDayEnd(date: Date): boolean {
    const result = this.getTimeForDayEndCheck(date) >= this.getDayEnd();
    return result; //for debug
  }
  static isTimeEqualsDayEnd(date: Date): boolean {
    const result = this.getTimeForDayEndCheck(date) === this.getDayEnd();
    return result; //for debug
  }
  static getTimeForDayEndCheck(date: Date): number {
    return date.getHours();
  }
  static getDayEnd(): number {
    return DAY_END;
  }
}
